/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { RouteConfig } from 'vue-router';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { withdrawalsPermission, balancePermissions, payoutsConfigurationPermissions, pendingPayoutsPermissions } from './permissions';
import { checkPermissionsAndCommpixCredentials, checkPermissionsAndMasspaymentCredentials } from '../routeGuards';
import { NAVBAR_TYPE_LIGHT } from '@/util/constants/config';
import { ROUTES } from './routes';

const { WITHDRAWALS, BALANCE, PAYOUTS_CONFIGURATION, PENDING_PAYOUTS, } = ROUTES;

const WithdrawalsHome = () =>
  import(
    /* webpackChunkName: "Withdrawals" */
    '@/views/Pix/Withdrawals.vue'
  );

const BalanceHome = () =>
  import(
    /* webpackChunkName: "Balance" */
    '@/views/Pix/Balance.vue'
  );

const PayoutsConfigurationHome = () =>
  import(
    /* webpackChunkName: "PayoutsConfiguration" */
    '@/views/Pix/PayoutsConfiguration.vue'
  );

const PendingPayoutsHome = () =>
  import(
    /* webpackChunkName: "PendingPayouts" */
    '@/views/Pix/PendingPayouts.vue'
  );

const pixRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: WITHDRAWALS.route,
      name: WITHDRAWALS.name,
      component: WithdrawalsHome,
      beforeEnter: checkPermissionsAndCommpixCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: withdrawalsPermission,
      },
    },
    {
      path: BALANCE.route,
      name: BALANCE.name,
      component: BalanceHome,
      beforeEnter: checkPermissionsAndMasspaymentCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: balancePermissions,
      },
    },
    {
      path: PAYOUTS_CONFIGURATION.route,
      name: PAYOUTS_CONFIGURATION.name,
      component: PayoutsConfigurationHome,
      beforeEnter: checkPermissionsAndMasspaymentCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: payoutsConfigurationPermissions,
      },
    },
    {
      path: PENDING_PAYOUTS.route,
      name: PENDING_PAYOUTS.name,
      component: PendingPayoutsHome,
      beforeEnter: checkPermissionsAndMasspaymentCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: pendingPayoutsPermissions,
      },
    }
  ],
};
export default pixRoute;
